import cx from 'classnames';
import React, { forwardRef, ReactNode, RefObject } from 'react';

import { useRobotSelector } from '../context';
import { RobotProblem, RobotSkin } from '../robot.types';

// @ts-ignore
import styles from './robot__field.module.scss';
import { getResourceUrl } from './utils';

interface Props {
    children?: ReactNode;
    className?: string;
    skin?: RobotSkin;
    resources?: RobotProblem['resources'];
}

const FieldBgRef = ({ className, children, skin, resources }: Props, ref: RefObject<HTMLDivElement>) => {
    return (
        <div
            className={cx(styles.bg, className)}
            ref={ref}
            style={{
                backgroundColor: skin?.page?.color,
                backgroundImage: getResourceUrl(resources, skin?.page),
            }}
        >
            {children}
        </div>
    );
};

export const FieldBg = forwardRef(FieldBgRef);

interface RobotFieldBgProps {
    className?: string;
    children?: ReactNode;
}

const RobotFieldBg = (props: RobotFieldBgProps) => {
    return (
        <FieldBg
            ref={useRobotSelector((s) => s.fieldBgRef)}
            resources={useRobotSelector((s) => s.problem.resources)}
            skin={useRobotSelector((s) => s.problem.markup.options.skin)}
            {...props}
        />
    );
};

export default RobotFieldBg;
